import { Navigate, useParams } from 'react-router';

export default function RedirectLegacyFamily() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/family/${id}/profile`} replace />;
}
